import { useEffect, useState } from "react";

const Q = "(max-width: 767px)";

export const useIsMobile = () => {
  const [m, setM] = useState(() => typeof window !== "undefined" && window.matchMedia(Q).matches);
  useEffect(() => {
    const mq = window.matchMedia(Q), f = () => setM(mq.matches);
    mq.addEventListener("change", f);
    return () => mq.removeEventListener("change", f);
  }, []);
  return m;
};
